import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import Reader from 'react-qr-reader';
import { styled } from './styled.js';
import { createImgSize } from './util.js';
const DEFAULT_DELAY = 150;
const DEFAULT_ERROR = (error) => {
    console.error('@polkadot/react-qr:Scan', error.message);
};
function Scan({ className = '', delay = DEFAULT_DELAY, onError = DEFAULT_ERROR, onScan, size, style = {} }) {
    const containerStyle = useMemo(() => createImgSize(size), [size]);
    const _onError = useCallback((error) => onError(error), [onError]);
    const _onScan = useCallback((data) => data && onScan(data), [onScan]);
    return (_jsx(StyledDiv, { className: className, style: containerStyle, children: _jsx(Reader, { className: 'ui--qr-Scan', delay: delay, onError: _onError, onScan: _onScan, style: style }) }));
}
const StyledDiv = styled.div `
  .ui--qr-Scan {
    display: inline-block;
    height: 100%;
    transform: matrix(-1, 0, 0, 1, 0, 0);
    width: 100%;

    video {
      margin: 0;
    }
  }
`;
export const QrScan = React.memo(Scan);
